export enum CopyConfigMappingFields {
  FromModelId = 'FromModelId',
  ToModelId = 'ToModelId'
}
